const segment = (value) => {
  if (value === undefined || value === null || value === "") {
    throw new TypeError("An endpoint identifier is required.");
  }
  return encodeURIComponent(String(value));
};

const detail = (collection, id) => collection + segment(id) + "/";

// Paths follow the migration checklist and confirmed backend contracts.
export const endpoints = {
  auth: {
    login: "login",
    setup: "2fa/setup",
    confirm: "2fa/confirm",
    status: "2fa/status",
    logout: "logout",
    logoutAll: "logoutall",
    sessions: "sessions",
    session: (id) => "sessions/" + segment(id),
  },
  student: {
    profile: "student-panel/",
    detail: (id) => detail("student-panel/", id),
    changePassword: "student-panel/change-password/",
    changeAvatar: "student-panel/change-avatar/",
  },
  exams: {
    list: "exam-platform/",
    entry: (id) => "exam-platform/exam/" + segment(id),
    flow: (id, action) =>
      "exam-platform/exam/" + segment(id) + "/v2/flow/" + segment(action),
    choice: (id, action) =>
      "exam-platform/exam/" + segment(id) + "/v2/choice/" + segment(action),
  },
  classrooms: {
    headlines: "classroom/headlines/",
    byHeadline: "classroom/get_by_headline/",
    detail: (id) => detail("classroom/", id),
    progress: (id) => detail("classroom/", id) + "video-progress/",
    presence: (id) => detail("classroom/", id) + "update_presence/",
  },
  assignments: {
    list: "assignment-platform/",
    detail: (id) => "assignment-platform/" + segment(id),
    upload: (id) => detail("assignment-platform/", id) + "upload/",
  },
  management: {
    users: "management/users/",
    user: (id) => detail("management/users/", id),
    groups: "management/groups/",
    exams: "management/exams/",
    assignments: "management/assignments/",
    changePassword: "management/change-password/",
    uploadUsers: "management/upload-excel/",
    toggleActivation: (id) => detail("management/users/", id) + "toggle_activation/",
    presenceSummary: (id) => detail("management/users/", id) + "classroom_presence_summary/",
    exportExams: (id) => detail("management/groups/", id) + "export_exam_scores/",
    exportAssignments: (id) => detail("management/groups/", id) + "export_assignment_scores/",
    deactivate: "management/students/deactivate/",
    reactivate: "management/students/reactivate/",
  },
  sms: {
    examRecipients: (id) => detail("management/exams/", id) + "sms-recipients/",
    assignmentRecipients: (id) => detail("management/assignments/", id) + "sms-recipients/",
    sendExam: (id) => detail("management/exams/", id) + "send-sms/",
    sendAssignment: (id) => detail("management/assignments/", id) + "send-sms/",
    custom: "management/smsmanager/custom/",
  },
  records: {
    students: "management/student-records/",
    student: (nationalId) => detail("management/student-records/", nationalId),
    history: (nationalId) => detail("management/student-records/", nationalId) + "history/",
    years: "management/year-records/",
    offline: "management/offline-exam-scores/",
    userYears: (id) => detail("management/users/", id) + "year_records/",
    attendance: (id) => detail("management/users/", id) + "attendance/",
    uploadExam: "management/upload-offline-exam/",
    uploadAttendance: "management/upload-attendance/",
  },
  notifications: {
    list: "management/notifications/",
    own: (username) => detail("management/notifications/", username) + "user/",
    dismiss: (id) => detail("management/notifications/", id) + "read/",
  },
  schema: "api/schema/",
};
